import router from "@/router";
import surveys from "@/urls/roles/admin";

import {
  sendPostRequest, sendGetRequest, sendPatchRequest, sendDeleteRequest, makeGetRequest, finalizeRequest
} from "@/helper/requests";
import names from "@/modules/administrative/routers/names";

const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  //ADMIN
  loadSurveyList: ({commit}, {url, finalizer, catcher}) => {
    /**
     * Загружает список опросов
     * @param {Function} commit - Функция для вызова мутаций
     * @param {string} url - URL для запроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url)
      url = surveys.ADMIN.SURVEY.LIST()
    sendGetRequest(
      url,
      (data) => finalizer(data, url),
      catcher
    )
  },
  createSurvey: ({commit}, {data, finalizer, catcher}) => {
    /**
     * Создает новый опрос
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для создания опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.SURVEY.LIST()
    sendPostRequest(
      url, data, finalizer, catcher,
    )
  },
  duplicateSurvey: ({commit}, {id, finalizer, catcher}) => {
    /**
     * Дублирует существующий опрос
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор опроса для дублирования
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.SURVEY.DUPLICATE(id)
    sendPostRequest(url, null, finalizer, catcher)
  },
  updateSurvey: ({commit}, {data, id, finalizer, catcher}) => {
    /**
     * Обновляет существующий опрос
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Обновленные данные опроса
     * @param {string|number} id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.SURVEY.EDIT(id)
    sendPatchRequest(
      url, data, finalizer, catcher
    )
  },
  loadSurveyDetail: ({commit, getters}, {id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию об опросе
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Function} getters - Геттеры Vuex
     * @param {number} id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.SURVEY.DETAIL(id)
    sendGetRequest(
      url,
      finalizer,
      catcher
    )
  },
  deleteSurvey: ({commit}, {item, finalizer, catcher}) => {
    /**
     * Удаляет опрос
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} item - Объект опроса для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.SURVEY.DELETE(item.id)
    sendDeleteRequest(url, finalizer, catcher)
  },
  loadStatisticFile: ({commit}, {id,get, finalizer, catcher}) => {
    /**
     * Загружает статистический файл
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор опроса
     * @param {Object} get - Параметры запроса для фильтрации статистики
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.FILE.UNLODING(id, get)
    sendGetRequest(
        url,
        finalizer,
        catcher
    )
  },
  surveyGetKindParam: ({commit}, {survey_id, search, finalizer, catcher}) => {
    /**
     * Получает параметры типа опроса с возможностью поиска
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {string} search - Строка поиска для фильтрации параметров
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} params - Функция-обработчик ошибок
     */
    let get = {}
    if (search) get['search'] = search
    let url = surveys.ADMIN.KIND_PARAM.GET_KIND_PARAM(survey_id, get)
    sendGetRequest(
        url,
        finalizer ? finalizer : () => {},
        catcher ? catcher : () => {},
    )
  },
  surveyListKindParam: ({commit}, {survey_id, finalizer, catcher}) => {
    /**
     * Загружает список всех параметров типа опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.KIND_PARAM.LIST(survey_id)
    sendGetRequest(
        url,
        finalizer,
        catcher
    )
  },
  surveyCreateKindParam: ({commit}, {survey_id, data, finalizer, catcher}) => {
    /**
     * Создает новый параметр типа опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Object} data - Данные для создания параметра
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.KIND_PARAM.CREATE(survey_id)
    sendPostRequest(
        url,
        data,
        finalizer,
        catcher
    )
  },
  surveyDeleteKindParam: ({commit}, {survey_id, id, finalizer, catcher}) => {
    /**
     * Удаляет параметр типа опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} id - Идентификатор параметра для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.KIND_PARAM.DELETE(survey_id, id)
    sendDeleteRequest(
        url,
        finalizer,
        catcher
    )
  },
  surveyDeleteAllKindParam: ({commit}, {survey_id, finalizer, catcher}) => {
    /**
     * Удаляет все параметры типа опроса
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.KIND_PARAM.DELETEALL(survey_id)
    sendDeleteRequest(
        url,
        finalizer,
        catcher
    )
  },
  personalLinkList: ({commit}, {survey_id, finalizer, catcher}) => {
    /**
     * Загружает список персональных ссылок-приглашений
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.INVITE.LIST(survey_id)
    sendGetRequest(
        url,
        finalizer,
        catcher
    )
  },
  personalLinkCreate: ({commit}, {survey_id, data, finalizer, catcher}) => {
    /**
     * Создает новую персональную ссылку-приглашение
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {Object} data - Данные для создания ссылки
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.INVITE.CREATE(survey_id)
    sendPostRequest(
        url,
        data,
        finalizer,
        catcher
    )
  },
  personalLinkDetail: ({commit}, {survey_id, id, finalizer, catcher}) => {
    /**
     * Загружает детальную информацию о персональной ссылке
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} id - Идентификатор ссылки
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.INVITE.DETAIL(survey_id, id)
    sendGetRequest(
        url,
        finalizer,
        catcher
    )
  },
  personalLinkDelete: ({commit}, {survey_id, id, finalizer, catcher}) => {
    /**
     * Удаляет персональную ссылку-приглашение
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} survey_id - Идентификатор опроса
     * @param {number} id - Идентификатор ссылки для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.INVITE.DELETE(survey_id, id)
    sendDeleteRequest(
        url,
        finalizer,
        catcher
    )
  },
  surveySendInvite: ({commit}, {data, survey_id, finalizer, catcher}) => {
    /**
     * Отправляет приглашение по email
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для отправки приглашения
     * @param {number} survey_id - Идентификатор опроса
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.INVITE.SEND(survey_id)
    sendPostRequest(
        url,
        data,
        finalizer,
        catcher
    )
  },

}


export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
